import Vue from 'vue'
import VueRouter from 'vue-router'
import Map from '@/components/Map'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Coverage',
    component: Map
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
